import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for SSO token from cookie (server redirect flow)
    const ssoToken = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('sso_token='));
    if (ssoToken) {
      const token = ssoToken.split('=')[1];
      if (token) {
        localStorage.setItem('access_token', token);
        // Clear the cookie
        document.cookie = 'sso_token=; max-age=0; path=/';
        document.cookie = 'sso_user=; max-age=0; path=/';
      }
    }

    const token = localStorage.getItem('access_token');
    if (token) {
      authAPI.me()
        .then(res => {
          setUser(res.data);
          localStorage.setItem('user', JSON.stringify(res.data));
        })
        .catch(() => {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('access_token', res.data.access_token);
    localStorage.setItem('refresh_token', res.data.refresh_token);
    const userRes = await authAPI.me();
    setUser(userRes.data);
    localStorage.setItem('user', JSON.stringify(userRes.data));
    
    // Dispatch event to notify RBACProvider to refresh
    window.dispatchEvent(new Event('userLoggedIn'));
    
    return userRes.data;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
